import { render } from "./Widget2.vue?vue&type=template&id=8fc75fc2"
import script from "./Widget2.vue?vue&type=script&lang=js"
export * from "./Widget2.vue?vue&type=script&lang=js"
script.render = render

export default script